var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB2CLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 30,
    viewBox: "0 0 51 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5176 23.7507C40.2999 23.7542 38.1685 22.9037 36.5779 21.3806C34.9874 19.8575 34.0634 17.7823 34.0031 15.5974C33.9429 13.4125 34.751 11.2908 36.2552 9.68476C37.7594 8.07869 39.8407 7.1153 42.0553 7H42.9946C45.1657 7.11785 47.2086 8.04997 48.7045 9.60517C50.2004 11.1604 51.0358 13.2207 51.0393 15.3637H47.5725C47.5725 14.3818 47.2771 13.422 46.7236 12.6056C46.1701 11.7892 45.3834 11.1528 44.463 10.7771C43.5426 10.4013 42.5298 10.303 41.5527 10.4946C40.5755 10.6861 39.678 11.159 38.9735 11.8533C38.2691 12.5476 37.7893 13.4321 37.595 14.3952C37.4006 15.3582 37.5004 16.3564 37.8816 17.2635C38.2629 18.1706 38.9085 18.946 39.7368 19.4915C40.5652 20.037 41.5391 20.3281 42.5354 20.3281L42.5176 23.7507Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.999 27.0433V30.4629H17.0533V28.7575C17.0447 26.5434 17.9278 24.4163 19.5088 22.8433C21.0899 21.2703 23.2396 20.3799 25.4862 20.3675C26.4824 20.3675 27.4563 20.0764 28.2847 19.5309C29.113 18.9854 29.7587 18.21 30.1399 17.3029C30.5212 16.3958 30.6209 15.3976 30.4266 14.4346C30.2322 13.4715 29.7525 12.587 29.048 11.8927C28.3435 11.1984 27.446 10.7256 26.4689 10.534C25.4918 10.3424 24.479 10.4408 23.5585 10.8165C22.6381 11.1923 21.8514 11.8286 21.2979 12.645C20.7444 13.4614 20.449 14.4212 20.449 15.4031H17V15.1461C17.0609 12.9828 17.9687 10.9266 19.5334 9.40819C21.0981 7.88981 23.1982 7.02705 25.3939 7.00063C27.5896 6.9742 29.7105 7.78617 31.3124 9.26644C32.9142 10.7467 33.8727 12.7805 33.9872 14.9417V15.8586C33.866 18.0001 32.9176 20.0146 31.3367 21.4885C29.7558 22.9624 27.6624 23.7839 25.4862 23.7843C24.4589 23.7775 23.4554 24.0883 22.6167 24.6729C21.7779 25.2575 21.1463 26.0865 20.8105 27.0433H33.999Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0168 14.9314C17.0144 17.1543 16.1174 19.2854 14.5226 20.8573C12.9277 22.4291 10.7653 23.3132 8.50988 23.3155V19.8988C9.50614 19.8988 10.48 19.6076 11.3084 19.0621C12.1367 18.5166 12.7824 17.7413 13.1636 16.8341C13.5449 15.927 13.6446 14.9288 13.4503 13.9658C13.2559 13.0028 12.7762 12.1182 12.0717 11.4239C11.3672 10.7296 10.4697 10.2568 9.49258 10.0652C8.51547 9.87366 7.50266 9.97197 6.58223 10.3477C5.66181 10.7235 4.8751 11.3598 4.32161 12.1762C3.76812 12.9926 3.47269 13.9524 3.47269 14.9343H0V0H3.46677V8.17677C4.71426 7.265 6.19172 6.70811 7.73819 6.56678C9.28466 6.42546 10.8408 6.70511 12.2371 7.37528C13.6335 8.04544 14.8164 9.08042 15.6571 10.3675C16.4978 11.6545 16.964 13.1442 17.0049 14.6744L17.0168 14.9314Z",
    fill: "url(#paint2_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 34.867,
    y1: 19.0753,
    x2: 49.4972,
    y2: 10.5041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#631BCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#4F3AD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3365E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#1D87F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0D9FF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#03AEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 866.271,
    y1: 2106.7,
    x2: 2188.63,
    y2: 1553.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#631BCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#4F3AD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3365E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#1D87F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0D9FF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#03AEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: -5.10506,
    y1: 1180,
    x2: 888.621,
    y2: 803.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#631BCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#4F3AD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3365E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#1D87F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0D9FF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#03AEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B3FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2CLogo);
export default __webpack_public_path__ + "static/media/b2c-logo.d0ba9962a51aad48e59d302213c89567.svg";
export { ForwardRef as ReactComponent };